var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticClass:"main-loader"},[_c('div',{staticClass:"main-loader-content"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea837126","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/ui/p-main-loader.vue
// module id = 977
// module chunks = 115